import React, { useEffect, useState } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';

const Invoice = ({ getInvoiceList, invoiceList }) => {
  const [headers, setHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(10);
  const [limit] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    if (getInvoiceList !== null)
      (async () => {
        setIsLoading(true);
        await getInvoiceList(currentPage, limit);
        setIsLoading(false);
      })();
  }, [getInvoiceList, currentPage, limit]);

  useEffect(() => {
    invoiceList &&
      invoiceList.upfrontheaders &&
      Object.values(invoiceList.upfrontheaders) !== undefined &&
      setHeaders(
        invoiceList &&
          invoiceList.upfrontheaders && [
            ...Object.values(invoiceList.upfrontheaders),
            ...['Actions'],
          ]
      );
    setTableData(
      invoiceList &&
        invoiceList.upfrontheaders && [
          ...Object.keys(invoiceList.upfrontheaders),
          ...['id'],
        ]
    );
    setList(invoiceList && invoiceList.data && invoiceList?.data?.results);

    if (invoiceList?.data) {
      setPageCount(Math.ceil(invoiceList?.data?.count / limit));
    }
  }, [invoiceList, limit]);

  useEffect(() => {
    // headers.length > 0 && !(headers.some((obj)=> obj === 'Actions')) && setHeaders([... headers, ...['Actions']])
    const actions = [
      {
        name: 'View Details',
        link: '/dashboard/brand-activation/invoice/view-details',
      },
    ];
    if (list !== undefined && list.length > 0 && tableData.length > 0) {
      const data = list.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: actions,
          }
        )
      );
      data !== undefined && setListData(data);
    }
  }, [list, tableData]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent"
      >
        {' '}
        <img src={Images.Filter} alt="" />
        {localization.showFilters}
      </Button>
    );
  };

  const onPageChange = async (val) => {
    setCurrentPage(val.selected + 1);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getInvoiceList(currentPage, limit, filterData);
    setIsLoading(false);
    filterToggle();
  };

  return (
    <Layout
      title={localization.invoice}
      isLoading={isLoading}
      // Buttons={headerBtns}
    >
      <TableSection
        data={listData.length > 0 && listData}
        isId={false}
        headers={headers.length > 0 && headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={invoiceList && invoiceList.data && invoiceList.data.results}
        srNo={limit * currentPage - limit + 1}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        status={[
          { id: 1, name: 'Pending' },
          { id: 3, name: 'Partial' },
          { id: 8, name: 'Completed' },
        ]}
        invoiceFilters={filterData}
      />
    </Layout>
  );
};

export default Invoice;
